<div class="w-100 h-100 d-flex flex-column align-items-start wrapper animated fadeIn">
	<button data-test-id="btn-back" type="button" class="btn btn-back" (click)="close.emit()">Back</button>
	<div class="header d-flex align-items-baseline">
		<h2 data-test-id="title" class="title mb-0">{{ title }}</h2>
		<p data-test-id="subtitle" class="subtitle mb-0">{{ subtitle }}</p>
	</div>
	<div class="chart-wrapper">
		<ng-container *ngIf="!!chartUpdateOptions; else loading">
			<div data-test-id="chart" echarts class="chart" [options]="chartUpdateOptions"></div>
		</ng-container>
	</div>
</div>

<ng-template #loading>
	<app-spinner data-test-id="spinner"></app-spinner>
</ng-template>
